import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Одноразовая метка для идемпотентности счёта: живёт ровно один открытый экран
 * чекаута. `crypto.randomUUID` есть в любом Telegram-webview (https), фолбэк на
 * случай старого webview без него.
 */
export function newNonce(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '');
    }
  } catch {
    // ниже фолбэк
  }
  let out = '';
  while (out.length < 32) out += Math.random().toString(36).slice(2);
  return out.slice(0, 32);
}
